<template>
  <div
    class="product-list-item d-flex"
  >
    <div v-if="showImg" class="mr-2" :class="{'forced-ske': !src}">
      <img
        :src="src"

        width="50"
        height="50"
      >
    </div>

    <div>
      <div>
        <span v-if="name" class="name" :class="{ske}">
          {{ name }}
        </span>
        <span v-else-if="category" class="name" :class="{ske}">
          {{ category }}
        </span>
        <span v-if="sku && !minimize" class="sku" :class="{ske}">
          {{ `, ${sku}` }}
        </span>
      </div>
      <div v-if="!minimize">
        <span v-if="recommended_retail_price" class="price" :class="{ske}">
          {{ `€ ${recommended_retail_price}` }}
        </span>
        <span v-if="website" class="website" :class="{ske}">
          {{ `, ${website}` }}
        </span>
      </div>
      <div v-else class="info">
        <span :class="{ske}">
          Sku: {{ sku }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    name: String,
    category: String,
    sku: String,
    website: String,
    src: String,
    recommended_retail_price: [String, Number],

    showImg: Boolean,
    ske: Boolean,
    minimize: Boolean,
  },
}

</script>

<style scoped>

.product-list-item {
  padding: 6px;
}

.name {
  font-weight: 500;
}

.product-list-item:hover {
  background-color: rgba(243, 244, 246, 1) !important;
  cursor: pointer;
}

.info {
  font-size: 0.75em;
  margin-top: -4px;
  color: #96999c;
}

.product-list-item {
  border-top: 2px solid rgba(243, 244, 246, 1) !important;
  min-height: 30px;
}

img {
  border-radius: 1px;
  border-radius: 1px;
  border: 1px solid #E3E3E3;
}

</style>
